import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useNavbarContext } from '../../../contexts/NavbarProvider';
import useFeatureBasedPermissions from '../../../hooks/useFeatureBasedPermissions';
import { NavButton } from '../../../types/common';
import { rootPath } from '../../../utils/commonFunctions';

const SideNavButton = ({ route }: { route: NavButton }) => {
  // integration of react-router-dom hooks here
  const { pathname } = useLocation();

  // integration of context hooks here
  const { showNavbar, isMobile } = useNavbarContext();
  const { currentUserType } = useAuthContext();

  // integration of custom hooks here
  const { hasReadPermission } = useFeatureBasedPermissions('');

  // rendering side navbar button component here
  return (
    <>
      {route.accessibleTo === 'all' ||
      (currentUserType === 'client' && route.accessibleTo === 'client') ? (
        <div title={!showNavbar ? route.title : ''} className='relative'>
          <Link
            to={route.href}
            className={`relative block pr-2 py-4 pl-7 text-xl text-legal-brown duration-300 after:h-full after:w-0 after:absolute after:left-0 after:top-0 after:origin-left after:duration-300 whitespace-nowrap z-[5] ${
              rootPath(pathname) === route.matcher
                ? '!text-legal-dark-blue hover:opacity-70'
                : 'hover:after:w-full after:bg-legal-dark-gray hover:text-base-white'
            }`}
          >
            <span className='relative flex items-center gap-3 z-10'>
              <span>{route.icon}</span>
              <motion.p
                initial={
                  showNavbar ? { x: 0 } : isMobile ? { x: 0 } : { x: -260 }
                }
                animate={
                  showNavbar ? { x: 0 } : isMobile ? { x: 0 } : { x: -260 }
                }
              >
                {route.title}
              </motion.p>
            </span>
          </Link>

          <motion.div
            initial={{ width: 0 }}
            animate={
              rootPath(pathname) === route.matcher
                ? { width: '100%' }
                : { width: 0 }
            }
            className='absolute h-full w-full bg-legal-brown top-0 left-0'
          ></motion.div>
        </div>
      ) : route.whichFeature && hasReadPermission(route.whichFeature) ? (
        <div title={!showNavbar ? route.title : ''} className='relative'>
          <Link
            to={route.href}
            className={`relative block pr-2 py-4 pl-7 text-xl text-legal-brown duration-300 after:h-full after:w-0 after:absolute after:left-0 after:top-0 after:origin-left after:duration-300 whitespace-nowrap z-[5] ${
              rootPath(pathname) === route.matcher
                ? '!text-legal-dark-blue hover:opacity-70'
                : 'hover:after:w-full after:bg-legal-dark-gray hover:text-base-white'
            }`}
          >
            <span className='relative flex items-center gap-3 z-10'>
              <span>{route.icon}</span>
              <motion.p
                initial={
                  showNavbar ? { x: 0 } : isMobile ? { x: 0 } : { x: -260 }
                }
                animate={
                  showNavbar ? { x: 0 } : isMobile ? { x: 0 } : { x: -260 }
                }
              >
                {route.title}
              </motion.p>
            </span>
          </Link>

          <motion.div
            initial={{ width: 0 }}
            animate={
              rootPath(pathname) === route.matcher
                ? { width: '100%' }
                : { width: 0 }
            }
            className='absolute h-full w-full bg-legal-brown top-0 left-0'
          ></motion.div>
        </div>
      ) : null}
    </>
  );
};

export default SideNavButton;
